import { useNavigate } from "react-router-dom";
import { handleError } from "./messageApiService";

export const setTokens = async (authRes: any) => {
  console.log(authRes)
  return Promise.resolve().then(function () {
    localStorage.setItem('access_token', JSON.stringify(authRes.access_token));
    localStorage.setItem('refresh_token', JSON.stringify(authRes.refresh_token));
    localStorage.setItem('expires_in', authRes.expires_in);
    const expirationDate = new Date(new Date().getTime() + authRes.expires_in * 1000) // Set the expiration date to 1 hour from now
    localStorage.setItem('expirationDate', expirationDate.toISOString())
  })
};

export const removeTokens = () => {
  localStorage.removeItem('user');
  localStorage.removeItem('access_token');
  localStorage.removeItem('refresh_token');
  localStorage.removeItem('is_access_allowed');
  localStorage.removeItem('user_role');
  localStorage.removeItem('expires_in');
  localStorage.removeItem('expirationDate');
};

export const getLocalAccessToken = () => localStorage.getItem('access_token')?.slice(1, -1);
export const getRefreshToken = () => localStorage.getItem('refresh_token')?.slice(1, -1);
export const getExpiryOfToken = () => localStorage.getItem('expires_in');

export const setUser = (user: any) => localStorage.setItem('user', JSON.stringify(user));
export const getUser = () => localStorage.getItem('user');

export const setIsAccessAllowed = (data: boolean) => localStorage.setItem('is_access_allowed', JSON.stringify(data));
export const getIsAccessAllowed = () => localStorage.getItem('is_access_allowed');

export const signOut = () => {
  localStorage.removeItem('user');
  localStorage.removeItem('access_token');
  localStorage.removeItem('refresh_token');
  localStorage.removeItem('is_access_allowed');
  localStorage.removeItem('user_role');
  localStorage.removeItem('expires_in');
  localStorage.removeItem('expirationDate');
  window.location.href = '/login';
}
